//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.EngineeringObjectBaseBuilder.js";
import "../AME/AME.AspectDetailsBuilder.js";
import "../AME/AME.PageAttributeHolder.js";
let d=[[[1,"Aspects",0,"AME.AspectDetailsBuilder",0],[0,"Description",1,0],[1,"PageAttributeHolder",0,"AME.PageAttributeHolder",0],[0,"PageName",1,0],[0,"Type",1,0]],[[[],"SetDefaultClassificationCode",{},0,0],[["dccString"],"SetClassificationCode",{},1,0]],[]];
SPLM.AME.PageBuilder = class extends SPLM.AME.EngineeringObjectBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.PageBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.PageBuilder.Types = Object.freeze({
    "AspectStructureOverview" : "AspectStructureOverview", "CableDiagram" : "CableDiagram", "CableList" : "CableList", "OrderList" : "OrderList", "PartListBom" : "PartListBom", "PlugList" : "PlugList", "TableOfContent" : "TableOfContent", "TerminalDiagram" : "TerminalDiagram", "TerminalStripList" : "TerminalStripList", "TitlePage" : "TitlePage", "WireTubeConnectionLists" : "WireTubeConnectionLists", "WireList" : "WireList", "MultiLineSchematics" : "MultiLineSchematics", "SingleLineSchematics" : "SingleLineSchematics", "NetworkTopology" : "NetworkTopology", "PowerSupplyTopology" : "PowerSupplyTopology", "ViewPage" : "ViewPage", "FluidicDiagram" : "FluidicDiagram", "CabinetLayout" : "CabinetLayout", "SummarizeBom" : "SummarizeBom"});

export default SPLM;